import { useMsal } from '@azure/msal-react';
import { useState } from 'react';
import {
  TEDropdown,
  TEDropdownToggle,
  TEDropdownMenu,
  TEDropdownItem,
  TERipple,
} from 'tw-elements-react';
import CreateProjectPopup from '../CreateProjectPopup';
import { FaRegUser, FaChevronDown } from 'react-icons/fa';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useNotifications } from '../../contexts/NotificationContext';
import { Bell, PanelRightClose, User, UserPlus } from 'lucide-react';
import { isSidebarCollapsedAtom } from '../../atoms/sidebar';
import { useAtom } from 'jotai';
import NotificationStream from '../../pages/auth/NotificationStream';
import { UserContext } from '../UserContext';
import { useContext } from 'react';


function Navbar() {
  const { instance, inProgress } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const { unreadCount } = useNotifications();
  const location = useLocation();
  const isNotificationsPage = location.pathname === '/notifications';
  const [showCreateProjectPopup, setShowCreateProjectPopup] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const { userProfile } = useContext(UserContext);
  const navigate = useNavigate();

  const toggleCreateProjectPopup = () => {
    setShowCreateProjectPopup(!showCreateProjectPopup);
  };

  const [isCollapsed, setIsCollapsed] = useAtom(isSidebarCollapsedAtom);

  const handleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const confirmLogout = () => {
    setShowLogoutModal(false);
    instance.logoutRedirect();
  };

  const handleLogoutRedirect = () => {
    setShowLogoutModal(true);
  };

  // const handleProfileEdit = () => {
  //   if (inProgress === InteractionStatus.None) {
  //     instance.acquireTokenRedirect(b2cPolicies.authorities.editProfile);
  //   }
  // };

  const handleNavigateToProfile = () => {
    navigate('/userProfileDetails');
  };

  const handleTerms = () => {
    navigate('/terms-conditions');
  };

  const handlePrivacy = () => {
    navigate('/privacy-policy');
  };

  return (
    <>
      <div className="w-full z-50 top-0 fixed bg-[#FCFCFC] opacity-1 px-2 py-6">
        <div className="flex flex-row items-center">
          {/* Search form */}
          <div className="px-4 ">
            {/* {isCollapsed && <PanelRightClose className="text-gray-400 hover:text-gray-600 cursor-pointer" onClick={handleCollapse} size={20} />} */}
          </div>
          <form className="relative flex py-3 rounded-md flex-wrap items-stretch xl:mx-0 w-203px shadow-custom rounded-5 opacity-1">
            {/* <IoMdSearch className="absolute text-xl m-2 text-gray-400" />
            <input
              autoComplete="off"
              type="search"
              className="w-[300px] rounded-sm relative m-0 inline-block bg-transparent w-203px bg-clip-padding px-8 py-2 text-sm font-normal text-gray-700 transition duration-300 ease-in-out focus:outline-none focus:border-primary-600 focus:text-gray-700 focus:shadow-te-primary dark:text-gray-400 dark:placeholder:text-gray-400"
              placeholder="Search"
            /> */}
          </form>

          <ul className="fixed  right-12 flex items-center">
            <li className="relative p-1 mt-4">
              <p
                className={`flex items-center justify-center text-gray-500 hover:text-gray-700 focus:text-gray-700 relative w-12 h-12
                  ${isNotificationsPage ? 'after:content-[""] after:absolute after:w-12 after:h-12 after:rounded-full after:border-2 after:border-[#89AF3E] after:animate-pulse' : ''}`}
                
                aria-expanded="false"
              >

                <NotificationStream 
                  className={`dark:text-gray-400 text-4xl absolute ${isNotificationsPage ? 'text-[#89AF3E]' : ''}`}
                  userId={userProfile?.userId} />
                {/* <Bell
                  className={`dark:text-gray-200 text-4xl absolute ${isNotificationsPage ? 'text-[#89AF3E]' : ''}`}
                /> */}
                {/* {unreadCount > 0 && (
                  <span className="absolute -top-1 right-0 rounded-full bg-red-600 px-1.5 py-[1px] text-[0.6rem] text-white">
                    {unreadCount}
                  </span>
                )} */}
              </p>
            </li>

            {/* <li>

              <NotificationStream userId={userProfile?.userId} />
            </li> */}

            {/* User dropdown */}
            <li>
              <TEDropdown className="flex items-center pl-2">
                <TERipple rippleColor="light">
                  <TEDropdownToggle className="pt-4 pl-2 flex items-center">
                    <span className="user-icon ml-4 text-2xl bg-[#dadebb] rounded-full w-10 h-10 flex items-center justify-center">
                      <User />
                    </span>
                    <span className="ml-2 text-sm font-medium">
                      {activeAccount?.name}
                    </span>
                    <span className="ml-2 text-sm">
                      <FaChevronDown />
                    </span>
                  </TEDropdownToggle>
                </TERipple>
                <TEDropdownMenu>
                  <TEDropdownItem
                    as="button"
                    //  onClick={handleProfileEdit}
                  >
                    <div className="block w-full min-w-[160px]  whitespace-nowrap bg-transparent px-4 py-2 text-sm text-left font-normal pointer-events-auto text-neutral-700 hover:bg-neutral-100 active:text-neutral-800 active:bg-neutral-100 focus:bg-neutral-100 focus:text-neutral-800 focus:outline-none active:no-underline dark:text-neutral-200 dark:hover:bg-neutral-600 dark:focus:bg-neutral-600 dark:active:bg-neutral-600">
                      {activeAccount?.name}
                      <br /> <span className="text-xs text-gray-400">User</span>
                    </div>
                  </TEDropdownItem>
                  <TEDropdownItem as="button" onClick={handleNavigateToProfile}>
                    <div className="block w-full min-w-[160px] cursor-pointer whitespace-nowrap bg-transparent px-4 py-2 text-sm text-left font-normal pointer-events-auto text-neutral-700 hover:bg-neutral-100 active:text-neutral-800 active:bg-neutral-100 focus:bg-neutral-100 focus:text-neutral-800 focus:outline-none active:no-underline dark:text-neutral-200 dark:hover:bg-neutral-600 dark:focus:bg-neutral-600 dark:active:bg-neutral-600">
                      Profile
                    </div>
                  </TEDropdownItem>
                  <TEDropdownItem as="button" onClick={handleTerms}>
                    <div className="block w-full min-w-[160px] cursor-pointer whitespace-nowrap bg-transparent px-4 py-2 text-sm text-left font-normal pointer-events-auto text-neutral-700 hover:bg-neutral-100 active:text-neutral-800 active:bg-neutral-100 focus:bg-neutral-100 focus:text-neutral-800 focus:outline-none active:no-underline dark:text-neutral-200 dark:hover:bg-neutral-600 dark:focus:bg-neutral-600 dark:active:bg-neutral-600">
                      Terms & Conditions
                    </div>
                  </TEDropdownItem>
                  <TEDropdownItem as="button" onClick={handlePrivacy}>
                    <div className="block w-full min-w-[160px] cursor-pointer whitespace-nowrap bg-transparent px-4 py-2 text-sm text-left font-normal pointer-events-auto text-neutral-700 hover:bg-neutral-100 active:text-neutral-800 active:bg-neutral-100 focus:bg-neutral-100 focus:text-neutral-800 focus:outline-none active:no-underline dark:text-neutral-200 dark:hover:bg-neutral-600 dark:focus:bg-neutral-600 dark:active:bg-neutral-600">
                      Privacy & Policy
                    </div>
                  </TEDropdownItem>
                  <TEDropdownItem as="button" onClick={handleLogoutRedirect}>
                    <div className="block w-full min-w-[160px] cursor-pointer whitespace-nowrap bg-transparent px-4 py-2 text-sm text-left font-normal pointer-events-auto text-neutral-700 hover:bg-neutral-100 active:text-neutral-800 active:bg-neutral-100 focus:bg-neutral-100 focus:text-neutral-800 focus:outline-none active:no-underline dark:text-neutral-200 dark:hover:bg-neutral-600 dark:focus:bg-neutral-600 dark:active:bg-neutral-600">
                      Logout
                    </div>
                  </TEDropdownItem>
                </TEDropdownMenu>
              </TEDropdown>
            </li>
          </ul>

          {showCreateProjectPopup && (
            <CreateProjectPopup onClose={toggleCreateProjectPopup} />
          )}

          {showLogoutModal && (
            <div className="fixed inset-0 z-50 flex items-center justify-center">
              {/* Modal Backdrop */}
              <button
                className="fixed inset-0 backdrop-blur-md bg-opacity-50"
                onClick={() => setShowLogoutModal(false)}
              ></button>

              {/* Modal Content */}
              <div className="bg-white rounded-lg p-6 w-[425px] relative z-50">
                <h2 className="text-xl font-semibold mb-2">Confirm Logout</h2>
                <p className="text-gray-600 mb-6">
                  Are you sure you want to logout? You will need to sign in
                  again to access your account.
                </p>
                <div className="flex justify-end space-x-4">
                  <button
                    onClick={() => setShowLogoutModal(false)}
                    className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={confirmLogout}
                    className="px-4 py-2 text-sm text-white bg-red-600 hover:bg-red-700 rounded-md transition-colors"
                  >
                    Logout
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Navbar;